import React from 'react';
import './messages-inbox.css';
import { MessagePreview } from './message-preview';

const MessagesInbox = props => {
    const { messages, setActiveMessage, setStep, modalVisible } = props;

    return (
        <div className="messages-inbox">
            {messages.map(message => (
                <MessagePreview
                    key={message.messageID}
                    id={message.index}
                    sender={message.sender}
                    senderType={message.senderPhoto}
                    subject={message.subject}
                    onClick={() => {
                        setActiveMessage(message);
                        setStep('message');
                    }}
                    modalVisible={modalVisible}
                />
            ))}
        </div>
    );
};

export { MessagesInbox };
